import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import { decrypt } from "../../utils/encodingdecoding";
import { clearCampaigns } from "../../actions/campaigns";
import { clearCustomer } from "../../actions/customer";
import { clearSetting } from "../../actions/setting";
import { clearTransaction } from "../../actions/transaction";
import { clearBusinessGoal } from "../../actions/businessGoal";
import { logout } from "../../actions/authAction";
import { closeIcon, logo, logoutHover, logoutIcon, openIcon } from "../../Image/Index";
import { getSidebarMenu } from "./menus";
import { DUMMY_MENU_ACCESS } from "./menus/menuAccess";


const ChannelPartnerSidebar = (props) => {
    const { children } = props;
    const location = useLocation();
    const [toggle, setToggle] = useState(true);

    const [dropdownDocBtn, setDropdownDocBtn] = useState(false);
    const [activeBtn, setActiveBtn] = useState(false);
    const [dropdownSetting, setDropdownSetting] = useState(false);
    const [dropdownSettingBtn, setDropdownSettingBtn] = useState(false);
    const [apiDocBtn, setApiDocBtn] = useState(false);
    const [menuItem, setMenuItem] = useState([]);
    const [menuTree, setMenuTree] = useState([]);

    useEffect(() => {
        if (location.pathname.includes("customers-list")) {
            let tempCusPageIndex = JSON.parse(localStorage.getItem("CusPageIndex"));
            localStorage.setItem("CusPageIndex", JSON.stringify(tempCusPageIndex));
        } else {
            localStorage.setItem("CusPageIndex", JSON.stringify(1));
        }
        if (location.pathname.includes("transaction-list") || location.pathname.includes("starblaze-trans-list")) {
            let tempTransPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
            localStorage.setItem("TransPageIndex", JSON.stringify(tempTransPageIndex));
        } else {
            localStorage.setItem("TransPageIndex", JSON.stringify(1));
        }
        if (location.pathname.includes("qrcode-list")) {
            let tempQRPageIndex = JSON.parse(localStorage.getItem("QRPageIndex"));
            localStorage.setItem("QRPageIndex", JSON.stringify(tempQRPageIndex));
        } else {
            localStorage.setItem("QRPageIndex", JSON.stringify(1));
        }

        let commTabKey = decrypt(localStorage.getItem("key"));
        let commTabCode = decrypt(localStorage.getItem("code"));

        if (!commTabCode && !commTabKey) {
            return;
        } else {
            localStorage.removeItem("key");
            localStorage.removeItem("code");

        }
    }, [location]);
    useEffect(() => {
        setMenuTree(menuItem);
    }, [menuItem]);

      useEffect(() => {
    let menuAccess = [];
    try {
        const stored = localStorage.getItem("moduleAccess");
        menuAccess = (stored && JSON.parse(decrypt(stored))) || [];
    } catch (error) {
        menuAccess = [];
    }
    if (!menuAccess.some((access) => access.path)) {
        menuAccess = DUMMY_MENU_ACCESS;
    }

    setMenuItem(getSidebarMenu({ menuAccess }));
}, []);

    const menuMainTrigger = () => {
        let array = [...menuTree];
        array.forEach((elem) => {
            if (toggle) {
                elem.isActive = false;
                setDropdownDocBtn(false);
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
            }
        });
        setMenuTree(array);
        setToggle(!toggle);
    };
    const childrenMenu = (id, Index, api_doc, path) => {
        location.pathname === path && window.location.reload();
        let array = [...menuTree];
        array.forEach((elem) => {
            if (elem.id === id && elem.dropdown && !toggle) {
                elem.isActive = false;
                elem.isChildVisible = true;
                setDropdownDocBtn(false);
                setDropdownSetting(false);
                setActiveBtn(false);
                setApiDocBtn(false);
            } else if ((id === "btn" && toggle && Index === 2) || api_doc) {
                setDropdownDocBtn(true);
                setActiveBtn(true);
                elem.isChildVisible = false;
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
                api_doc ? setApiDocBtn(true) : setApiDocBtn(false);
            } else if (id === "btn" && toggle && Index === 1) {
                setDropdownSettingBtn(true);
                setDropdownSetting(false);
                elem.isChildVisible = false;
                setDropdownDocBtn(false);
                setActiveBtn(true);
                setApiDocBtn(false);
            } else if (id === "btn" && Index === 1) {
                setDropdownSettingBtn(!dropdownSettingBtn);
                setDropdownSetting(false);
                elem.isChildVisible = false;
                setDropdownDocBtn(false);
                setApiDocBtn(false);
            } else if (id === "btn" && toggle && Index === 3) {
                setDropdownSettingBtn(false);
                setDropdownSetting(true);
                elem.isChildVisible = false;
                setDropdownDocBtn(false);
                setActiveBtn(true);
                setApiDocBtn(false);
            } else if (id === "btn" && Index === 3) {
                setDropdownSetting(!dropdownSetting);
                setDropdownSettingBtn(false);
                elem.isChildVisible = false;
                setDropdownDocBtn(false);
                setApiDocBtn(false);
            } else if ((id === "btn" && Index == 2) || api_doc) {
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
                elem.isChildVisible = false;
                setDropdownDocBtn(!dropdownDocBtn);
                api_doc ? setApiDocBtn(true) : setApiDocBtn(false);
            } else if (toggle === false) {
                setDropdownDocBtn(false);
                setActiveBtn(false);
                setApiDocBtn(false);
                elem.isChildVisible = false;
            }
        });
        setMenuTree(array);
    };
    const menuChildTrigger = async (id, Index, path) => {
        location.pathname === path && window.location.reload();

        let array = [...menuTree];
        await array.forEach((elem) => {
            if (elem.id === id && elem.dropdown) {
                elem.isActive = !elem.isActive;
                setDropdownDocBtn(false);
                setActiveBtn(false);
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
                setApiDocBtn(false);
            } else if (id === "btn" && Index === 3) {
                setDropdownSetting(!dropdownSetting);
                setDropdownSettingBtn(false);
                setDropdownDocBtn(false);
                setActiveBtn(true);
                setApiDocBtn(false);
                elem.isActive = false;
            } else if (id === "btn" && Index === 2) {
                setDropdownDocBtn(!dropdownDocBtn);
                setActiveBtn(true);
                setDropdownSetting(false);
                setDropdownSettingBtn(false);
                elem.isActive = false;
            } else if (id === "btn" && Index === 1) {
                setDropdownSettingBtn(!dropdownSettingBtn);
                setDropdownDocBtn(false);
                setDropdownSetting(false);
                setActiveBtn(true);
                setApiDocBtn(false);
                elem.isActive = false;
            } else {
                setDropdownSettingBtn(false);
                setDropdownSetting(false);
                setDropdownDocBtn(false);
                setActiveBtn(false);
                setApiDocBtn(false);
                elem.isChildVisible = false;
                elem.isActive = false;
            }
        });

        setMenuTree(array);
    };

    const handleLogout = () => {
        logout();
        clearCampaigns();
        clearCustomer();
        clearSetting();
        clearTransaction();
        clearBusinessGoal();
        sessionStorage.clear();
        localStorage.clear();
    };
    return (
        <>
            <div className={`dashboard_dark ${toggle ? "openSidebar" : ""}`}>
                <div className="dashboard_dark__sidebar" id="sidebar">
                    <div className="dashboard__topSection">
                        <Link to="/dashboard">
                            <img src={logo} alt="" className="dashboard__logoBox" />
                        </Link>
                        <div className="dashboard__menuBox">
                            <span onClick={menuMainTrigger}>
                                <img src={closeIcon} alt="" className="inside" />
                                <img src={openIcon} alt="open-icon.png" className="outside" />
                            </span>
                        </div>
                    </div>

                    <div className="dashboard__menuMain">
                        <div className="dashboard__menuTop">
                            <ul>
                                {window.location.pathname == "/register" || window.location.pathname == "/contact-us-query" || window.location.pathname == "/alertNotification"
                                    ? menuTree.map((elem, index) => {
                                        const { id, name, iconOffHover, iconOnHover, path, className } = elem;
                                        return (
                                            <li key={`parentLi__${index}`} title={name}>
                                                <div id={className}>
                                                    <NavLink to={path} className="link" onClick={() => menuChildTrigger(id, null, path)}>
                                                        <figure className="icon">
                                                            {iconOffHover}
                                                            {iconOnHover}
                                                        </figure>
                                                        <span className="link_text">{name}</span>
                                                    </NavLink>
                                                </div>
                                            </li>
                                        );
                                    })
                                    : menuTree.map((elem, index) => {
                                        const { id, name, iconOffHover, iconOnHover, dropdown, path, isChildVisible, isActive, className, ids } = elem;

                                        return (
                                            <ul key={index}>
                                                <li key={id} title={name}>
                                                    {path ? (
                                                        <div className={className} id={ids}>
                                                            <NavLink to={path} className="link" onClick={() => menuChildTrigger(id, null, path)}>
                                                                <figure className="icon">
                                                                    {iconOffHover}
                                                                    {iconOnHover}
                                                                </figure>
                                                                <span className="link_text">{name}</span>
                                                            </NavLink>
                                                        </div>
                                                    ) : (
                                                        <div className={className} id={ids}>
                                                            <button type="button" className={isChildVisible ? "link active" : "link"} onClick={() => menuChildTrigger(id, null)}>
                                                                <figure className="icon">
                                                                    {iconOffHover}
                                                                    {iconOnHover}
                                                                </figure>
                                                                <span className="link_text">{name}</span>
                                                                {!isActive ? (
                                                                    <span className="link_icon">
                                                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                                                    </span>
                                                                ) : (
                                                                    <span className="link_icon">
                                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                    </span>
                                                                )}
                                                            </button>
                                                        </div>
                                                    )}
                                                    {dropdown && isActive && (
                                                        <ul className="childrenDropdown">
                                                            {dropdown.map((each, idx) => {
                                                                const { path, name } = each;
                                                                return (
                                                                    <li key={`childLi__${id}__${idx}`} title={name}>
                                                                        <NavLink to={path} onClick={() => childrenMenu(id, null, null, path)}>
                                                                            {name}
                                                                        </NavLink>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    )}
                                                </li>
                                            </ul>
                                        );
                                    })}
                            </ul>
                        </div>

                        <div className="dashboard__menuBottom">
                            <ul>
                                <li title="Logout">
                                    <NavLink className="link" to="/signin" aria-current="page" onClick={handleLogout}>
                                        <figure className="icon">
                                            <img src={logoutIcon} alt="" className="offHover" />
                                            <img src={logoutHover} alt="" className="onHover" />
                                        </figure>
                                        <span className="link_text">Logout</span>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="dashboard_dark__mainPage">{children}</div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    // dropdown:state.dropDownSetting
});

export default connect(mapStateToProps, {})(ChannelPartnerSidebar);
